// useDownloadContractAttachment.ts
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'

export const contractAttachmentDownloadQueryKey = [
  'contract-attachment-download'
]

type useContractAttachmentDownloadProps = {
  attachmentId: string
  attachment_name?: string
  contractId: string
  type?: 'flat' | 'offer'
  offset?: string
  limit?: string
}

export function useContractAttachmentDownload() {
  const getContractAttachmentDownload = async ({
    attachmentId,
    contractId,
    type,
    offset,
    limit
  }: useContractAttachmentDownloadProps) => {
    const response = await apiClient.get(
      `${SNA_PREFIX}contracts/${contractId}/attachments/${attachmentId}?`,
      {
        responseType: 'blob',
        params: {
          type,
          offset,
          limit
        }
      }
    )
    const blob = response.data
    const fileURL = URL.createObjectURL(blob)

    window.open(fileURL, '_blank')
  }

  const query = useQuery({
    queryKey: contractAttachmentDownloadQueryKey,
    queryFn: () => Promise.resolve(), // empty by default
    enabled: false
  })

  return {
    ...query,
    downloadContractAttachment: getContractAttachmentDownload
  }
}
